import React from "react";

import AfterLoginHeader from "../Layouts/AfterLoginHeader";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getAddReviewList,
  ResetAddReviewState,
} from "../../store/Slice/addReviewSlice";
import { useDispatch, useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import { getLabelDetailList } from "../../store/Slice/labelDetailSlice";

const AddReview = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = React.useRef(null);
  const location = useLocation();
  const { bookingDetails } = location.state || {};

  const isLoggedIn = sessionStorage.getItem("CustomerId");

  const [loading, setLoading] = React.useState("");

  const [rating, setRating] = React.useState(0);

  const [review, setReview] = React.useState("");
  const [hoverValue, setHoverValue] = React.useState(0);
  const [ratingError, setRatingError] = React.useState("");
  const [reviewError, setReviewError] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");

  const { addReviewData } = useSelector((state) => state.addReviewList);
  const { labelDetailData } = useSelector((state) => state.labelDetailList);

  const handleMouseEnter = (value) => {
    setHoverValue(value);
  };

  const handleMouseLeave = () => {
    setHoverValue(0);
  };

  const handleClick = (value) => {
    setRating((prev) => {
      const newRating = prev === value ? 0 : value;
      setHoverValue(0); // reset hover

      // Set error based on new rating
      if (newRating === 0) {
        setRatingError("Rating is required.");
      } else {
        setRatingError("");
      }

      return newRating;
    });
  };

  const handleReviewChange = (event) => {
    const reviewValue = event.target.value;
    setReview(reviewValue);
    event.target.value.trim() !== "" && setReviewError("");
    if (reviewValue.trim() === "" && reviewValue.length === 0) {
      setReviewError("This field is required.");
    } else if (reviewValue.length < 50) {
      setReviewError("Review must be at least 50 characters long.");
    } else {
      setReviewError("");
    }
  };

  const validateReviewForm = React.useCallback(() => {
    let isValid = true;
    setReviewError("");
    setRatingError("");

    if (review.trim() === "" && review.length === 0) {
      setReviewError("This field is required.");
      isValid = false;
    } else if (review.length < 50) {
      setReviewError("Review must be at least 50 characters long.");
      isValid = false;
    }
    if (rating < 1) {
      setRatingError("Rating is required.");
      isValid = false;
    }
    return isValid;
  }, [review, rating]);

  const handleAddReview = React.useCallback(
    (event) => {
      event.preventDefault();

      const isValidForm = validateReviewForm();
      if (isValidForm) {
        dispatch(
          getAddReviewList({
            iCustomerId:
              Number(isLoggedIn) === bookingDetails?.iCustomerId &&
              bookingDetails?.iCustomerId,
            iServiceId: bookingDetails?.iServiceId,
            iBookingId: bookingDetails?.iBookingId,
            vRole: "Customer",
            eType: "Customer",
            iRating: rating,
            tDescription: review,
          })
        );
        setLoading(true);
      } else {
        // console.log("Something Went Wrong");
      }
    },
    [dispatch, bookingDetails, rating, isLoggedIn, review, validateReviewForm]
  );

  React.useEffect(() => {
    if (addReviewData && addReviewData.code === 201) {
      toast.current.show({
        severity: "success",
        summary: "Review Added Successfully.",
        life: 2000,
        className: "custom-toast",
      });
      setTimeout(() => {
        setLoading(false);
        setReview("");
        setRating("");
        navigate("/reviews");
      }, 2000);
      dispatch(ResetAddReviewState());
    } else if (addReviewData && addReviewData.code === 404) {
      setLoading(false);
      setErrorMessage(addReviewData.message);
    } else if (addReviewData && addReviewData.code === 400) {
      setLoading(false);
      setErrorMessage(addReviewData.message);
    }
  }, [addReviewData, dispatch, navigate]);

  const handleCancelClick = () => {
    navigate("/booking");
  };

  const path = location.pathname.split("/")[1];

  React.useEffect(() => {
    dispatch(getLabelDetailList({ vSlug: path }));
  }, [dispatch, path]);

  const getLabels = React.useMemo(() => {
    if (labelDetailData?.code !== 200) return {};
    return labelDetailData.data.reduce((acc, item) => {
      acc[item.vLabel] = item.tText;
      return acc;
    }, {});
  }, [labelDetailData]);

  const addReviewHeading = getLabels["LBL_ADD_REVIEWS_HEADING"];

  const ratingLabel = getLabels["LBL_ADD_REVIEWS_RATING_HEADING"];
  const reviewLabel = getLabels["LBL_ADD_REVIEWS_YOUR_HERE_HEADING"];

  return (
    <div className="dashboard">
      <Toast ref={toast} />
      <div className="dashboard-app">
        <AfterLoginHeader />

        <div className="dashboard-content">
          <div className="session-big-section">
            <div className="row">
              <div className="col-xl-6 col-lg-10 mx-auto">
                <h2 className="dash-maintitle">{addReviewHeading}</h2>

                <div className="main-card profile-maincard">
                  <div className="dashprofile-card">
                    <div className="row justify-content-center">
                      <div className="col-xxl-11 col-lg-12">
                        <div className="login-form pt-0 pb-0">
                          <div className="row">
                            <div className="comment-section rating-page">
                              <div className="form-group mb-4">
                                <label
                                  className="form-label mb-3 d-block"
                                  htmlFor="give me rating"
                                >
                                  {ratingLabel}
                                </label>
                                <div
                                  style={{
                                    display: "inline-flex",
                                    fontSize: "40px",
                                    cursor: "pointer",
                                    marginTop: "00px",
                                    gap: "10px",
                                  }}
                                >
                                  {[1, 2, 3, 4, 5].map((star, startIndex) => (
                                    <span
                                      key={startIndex}
                                      onClick={() => handleClick(star)}
                                      onMouseEnter={() =>
                                        handleMouseEnter(star)
                                      }
                                      onMouseLeave={handleMouseLeave}
                                      style={{
                                        color:
                                          (hoverValue || rating) >= star
                                            ? "#FFB545"
                                            : "#DCDCDC",
                                        transition: "color 0.2s",
                                      }}
                                    >
                                      ★
                                    </span>
                                  ))}
                                </div>
                                {ratingError && (
                                  <div className="validation-error">
                                    {ratingError}
                                  </div>
                                )}
                              </div>
                              {/* <p>Selected Rating: {rating}</p> */}
                              <div className="rating-quoteDiv mb-3">
                                <label
                                  className="form-label mb-1"
                                  htmlFor="rating"
                                >
                                  {reviewLabel}
                                </label>

                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="88"
                                  height="68"
                                  viewBox="0 0 88 68"
                                  fill="none"
                                >
                                  <g opacity="0.8">
                                    <path
                                      d="M8.88562 0.824215L5.0284 6.38403C11.9796 9.99821 17.7758 15.4838 21.7522 22.2201L21.756 22.2264L21.7596 22.2329C23.7532 25.8504 25.0009 29.8278 25.4293 33.9317L25.5192 34.7929L24.7283 34.4402C21.4753 32.9895 17.8493 32.5803 14.3523 33.2697C10.8553 33.9591 7.66022 35.713 5.20929 38.2878C2.7584 40.8627 1.1727 44.1313 0.67091 47.6417C0.169125 51.152 0.776051 54.7308 2.40801 57.8831L2.40845 57.8839C5.19876 63.299 9.79564 65.8532 14.5722 66.4438C19.368 67.0367 24.3362 65.6464 27.7979 63.1671C32.6743 59.6026 36.0007 54.3224 37.0999 48.4031L37.0997 48.403L37.1026 48.3898C38.312 42.7331 38.1968 36.8753 36.7661 31.2699C35.3354 25.6645 32.6274 20.4616 28.8515 16.0643L28.8514 16.0644L28.8432 16.0544C23.5526 9.56041 16.8182 4.37794 9.17094 0.915424L8.88562 0.824215Z"
                                      stroke="#E1E1E1"
                                    />
                                    <path
                                      d="M58.3599 0.728767L54.4209 6.40189C65.2553 12.5 73.1904 20.881 74.9263 33.9896L75.0501 34.9238L74.2071 34.5025C71.9323 33.3655 69.3987 32.8379 66.8562 32.9714L66.8422 32.9721L66.8283 32.972C62.8152 32.9584 58.9265 34.3532 55.8455 36.9106C52.7646 39.468 50.6891 43.024 49.9835 46.9529L49.9835 46.9532C49.5165 49.545 49.6736 52.2101 50.4422 54.7298C51.2108 57.2494 52.5688 59.5521 54.4052 61.4488C56.2416 63.3454 58.5041 64.7818 61.007 65.6403C63.5096 66.4986 66.1812 66.7545 68.8025 66.3867C76.738 65.2588 81.6953 60.4425 84.7547 53.4727C86.4845 49.4026 87.3875 45.032 87.4116 40.6131C87.4357 36.1933 86.5802 31.8127 84.8941 27.7234L84.8941 27.7234L84.8908 27.7152C81.1297 18.1149 74.2688 10.0295 65.3862 4.73063L65.3799 4.72689L65.3738 4.72297C63.715 3.66665 62.0055 2.73083 60.2375 1.76293C59.6189 1.42431 58.9932 1.08177 58.3599 0.728767Z"
                                      stroke="#E1E1E1"
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div className="form-group mb-4">
                                {/* <label
                                      htmlFor="review"
                                      className="form-label"
                                    >
                                      Review
                                    </label> */}
                                <textarea
                                  style={{ height: "120px" }}
                                  className="form-control"
                                  placeholder="Write your review here..."
                                  value={review}
                                  onChange={handleReviewChange}
                                  maxLength={250}
                                />
                                {reviewError && (
                                  <div className="validation-error">
                                    {reviewError}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          {errorMessage && (
                            <div className="validation-error">
                              {errorMessage}
                            </div>
                          )}
                          <div className="col-lg-12">
                            <div className="d-flex gap-3">
                              {loading ? (
                                <>
                                  {" "}
                                  <button
                                    className="success-orangebtn"
                                    type="button"
                                    disabled
                                  >
                                    <span
                                      className="spinner-border spinner-border-sm me-1 custom-spinner"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Loading...
                                  </button>
                                </>
                              ) : (
                                <button
                                  type="submit"
                                  className="success-orangebtn"
                                  onClick={handleAddReview}
                                >
                                  Submit
                                </button>
                              )}
                              <button
                                className="success-orangebtn success-grayborderbtn"
                                onClick={handleCancelClick}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddReview;
